/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Impressum_Registration_TitleInputs */

const en_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registration`)
};

const de_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrierung`)
};

const fr_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inscription au registre`)
};

const es_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro`)
};

const it_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrazione`)
};

const nl_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registratie`)
};

const pl_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejestracja`)
};

const fi_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rekisteröinti`)
};

const da_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrering`)
};

const sv_impressum_registration_title = /** @type {(inputs: Impressum_Registration_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrering`)
};

/**
* | output |
* | --- |
* | "Registration" |
*
* @param {Impressum_Registration_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const impressum_registration_title = /** @type {((inputs?: Impressum_Registration_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Impressum_Registration_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_impressum_registration_title(inputs)
	if (locale === "fr") return fr_impressum_registration_title(inputs)
	if (locale === "es") return es_impressum_registration_title(inputs)
	if (locale === "it") return it_impressum_registration_title(inputs)
	if (locale === "nl") return nl_impressum_registration_title(inputs)
	if (locale === "pl") return pl_impressum_registration_title(inputs)
	if (locale === "fi") return fi_impressum_registration_title(inputs)
	if (locale === "da") return da_impressum_registration_title(inputs)
	if (locale === "sv") return sv_impressum_registration_title(inputs)
	return en_impressum_registration_title(inputs)
});